import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'i18nPrefixConcat',
})
export class I18nPrefixConcatPipe implements PipeTransform {
  transform(key: string, i18nPrefix: string, concatChar = '.'): string {
    return `${i18nPrefix}${concatChar}${key}`;
  }
}
